import { Ctx, KnownPermissionKey } from '..';
import { usePermission } from '../hooks';

interface PermissionProps {
  can: KnownPermissionKey;
  ctx?: Ctx;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function Permission({
  can = '*',
  ctx,
  children,
  fallback = null,
}: PermissionProps) {
  const canAccess = usePermission(can, ctx);

  if (!canAccess) {
    return fallback;
  }

  return children;
}
